module.exports = "/365FarmNet/dist/cropSequencePlanning.4860223e2c026173eba1c02a37d83944.html";